import { render, staticRenderFns } from "./footprints.vue?vue&type=template&id=b4e87720&lang=pug"
import script from "./footprints.vue?vue&type=script&lang=js"
export * from "./footprints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports